import { PropsWithChildren } from "react";
import styled from "styled-components";
import {
  ButtonProps,
  ModalFoot as ModalFootBase,
  ModalWrapper as ModalWrapperBase,
  shade800,
  shade850,
} from "@songtradr-one/components-frontend";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = { shared: staticText.shared };

// STYLES
export const ModalWrapper = styled(ModalWrapperBase)<{
  preventDismiss?: boolean;
}>`
  ${({ preventDismiss }) =>
    preventDismiss &&
    `
    padding-top: 1rem;
  `}
`;

export const ModalFoot = styled(ModalFootBase)`
  margin-top: 1.5rem;
  border-top: 1px solid ${shade850};
`;

export const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.5rem 1.5rem 0;
`;

export const MobileButtonsColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${shade800};
  margin-top: 1.5rem;
  padding: 1rem 1.5rem 0;
`;

// DATA

// TYPES
export interface Props extends PropsWithChildren {
  open: boolean;
  title: string;
  loading: boolean;
  description: string;
  confirmLabel: string;
  confirmVariant?: ButtonProps["$variant"];
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  onCancel?: () => void;
  className?: string;
  cancelLabel?: string;
  preventDismiss?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
